export const CONST = {
  TRACKING_NUMBER: $localize`Tracking Number`,
  ENTER_TRACKING_NUMBER: $localize`Enter Tracking Number`,
  SEPERATE_WITH_COMMAS: $localize`Separate Multiple Tracking Numbers With Commas`,
  INVALID_TRACKING_NUMBER: $localize`Invalid Tracking Number Format`,
  NONE: $localize`None`,
  HAZMAT: $localize`Hazmat`,
  DRY_ICE: $localize`Dry Ice`,
  FILE_UPLOAD: $localize`File Upload`,
  SUBMIT: $localize`Submit`,
  STATUS: $localize`Status`,
  REASON: $localize`Reason`,
  FLEX: $localize`Flex`,
  ULD_COUNT: $localize`ULD Count`,
  LOOSE_COUNT: $localize`Loose Count`,
  AMOUNT: $localize`Amount`,
  UNIT_OF_MEASURE: $localize`Unit of Measure`,
  REMOVE_TRACKING_NUMBER: {
    HEADER: $localize`Remove Tracking Number`,
    BODY: $localize`Removing the following Tracking Number?`,
    YES: $localize`Yes, Remove`,
    NO: $localize`No`.toUpperCase(),
  },
  WARNING: {
    CONFIRM_BUTTON: $localize`Confirm`,
    REJECT_BUTTON: $localize`Cancel`,
    HEADER: $localize`Load anyway?`,
  },
};

export interface TrackingNumberItem {
  trackingNumber: string;
  status: string;
  reason: string;
  flex: string;
}

export const UNIT_Of_MEASURE = [
  {
    label: $localize`LBS`,
    value: 'LBS',
  },
  {
    label: $localize`KGS`,
    value: 'KGS',
  },
];

export const CONTINUE_FLAG_MAPPING: Record<string, string> = {
  notOnFile: 'notOnFileContinue',
  loadChartOffPlan: 'loadChartOffPlanContinue',
  sortCodeOffPlan: 'sortCodeOffPlanContinue',
  sortDateOffPlan: 'sortDateOffPlanContinue',
  statusCheck: 'statusCheckUserContinue',
  inspectCv: 'inspectCvUserContinueLoad',
  inspectSecDes: 'inspectSecDesUserContinueLoad',
  inspectUld: 'inspectUldUserContinueLoad',
  inspectSec2: 'inspectSec2UserContinueLoad',
  inspectSec1: 'inspectSec1UserContinueLoad',
};
